import React from "react";
import ReactDOM from 'react-dom';
import "./fonts/fonts.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import configureStore from "./helpers/configureStore";
import * as serviceWorker from "./serviceWorker";
import "font-awesome/css/font-awesome.min.css";
import "sdk/translations";
import { SearchQueryProvider } from "./services/SearchQueryContext";
import * as Sentry from "@sentry/react";

const parseSampleRate = (value, fallback) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT ||
      process.env.REACT_APP_NODE_ENV ||
      process.env.NODE_ENV ||
      "development",
    initialScope: {
      tags: {
        app_layer: "frontend",
      },
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: parseSampleRate(
      process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
      0.1
    ),
    replaysSessionSampleRate: parseSampleRate(
      process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
      0.1
    ),
    replaysOnErrorSampleRate: parseSampleRate(
      process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
      1.0
    ),
  });
}

ReactDOM.render(
  <Provider store={configureStore}>
    <SearchQueryProvider>
      <App />
    </SearchQueryProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
